export const getAuthConfig = () => {
    if (window.location.hostname === "localhost") {
        return {
            auth: {
                username: process.env.REACT_APP_AUTH_USERNAME,
                password: process.env.REACT_APP_AUTH_PASSWORD
            }
        };
    }
    return null
};

export const getValidateConfig = () => {
    const headers = {'content-type': 'multipart/formdata'}
    if (window.location.hostname === "localhost") {
        return {
            headers: headers,
            auth: {
                username: process.env.REACT_APP_AUTH_USERNAME,
                password: process.env.REACT_APP_AUTH_PASSWORD
            }
        };
    }
    return {
        headers: headers
    }
}